import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { setPeriod } from '../../state/actions';
import { DateRangePicker } from '../../../CommonComponents/OPL/dates/DateRangePicker/DateRangePicker';
import { useRangePresets } from '../../hooks/useRangePresets';
import { useInceptionDate } from '../../hooks/useInceptionDate';
import { usePeriod } from '../../hooks/usePeriod';
import { dateToISO8601, iso8601ToDate } from '../../helpers/dates';
import { today } from '../../AccountPerformanceReporting.constants';
import { useOptions } from '../../hooks/useOptions';

interface Props {
  isVerticalLayout?: boolean;
}

export const PeriodSelector = ({ isVerticalLayout }: Props) => {
  const options = useOptions();

  const period = usePeriod();

  const rangePresets = useRangePresets();

  const inceptionDate = useInceptionDate();

  const dispatch = useDispatch();

  const range = useMemo(() => {
    if (!period) {
      return null;
    }
    return {
      ...period,
      dates: period.dates.map(date => iso8601ToDate(date)),
    };
  }, [period]);

  const rangePresetsWithDates = useMemo(
    () =>
      rangePresets.map(preset => ({
        ...preset,
        dates: preset.dates.map(date => iso8601ToDate(date)),
      })),
    [rangePresets],
  );

  if (!range) {
    return null;
  }

  return (
    <DateRangePicker
      range={range}
      onChange={selectedRange => {
        dispatch(
          setPeriod({
            ...selectedRange,
            dates: selectedRange.dates.map(date => dateToISO8601(date)),
          }),
        );
      }}
      presets={rangePresetsWithDates}
      minDate={inceptionDate ? iso8601ToDate(inceptionDate) : undefined}
      maxDate={iso8601ToDate(today)}
      isReadonly={!options.customPeriodEnabled.performance}
      isVerticalLayout={isVerticalLayout}
    />
  );
};
